import React, { lazy, Suspense, useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

//contexts
import { UserContext } from "../state/user/userContext";

//Pages
import Layout from "../components/layout";

const Setting = lazy(() => import("../pages/Setting"));
const CreateFromMnemonic = lazy(() => import("../pages/CreateFromMnemonic"));
const GenerateWallet = lazy(() => import("../pages/GenerateWallet"));
const RestoreWallet = lazy(() => import("../pages/RestoreWallet"));
const RestoreFromWallet = lazy(() => import("../pages/RestoreFromWallet"));
const RestoreFromMobileWallet = lazy(() => import("../pages/RestoreFromMobileWallet"));
const RestoreFromKeyFile = lazy(() => import("../pages/RestoreFromKeyFile"));
const AddDelegation = lazy(() => import("../pages/AddDelegation"));
const WalletInfo = lazy(() => import("../pages/WalletInfo"));
const CreateToken = lazy(() => import("../pages/CreateToken"));
const SendToken = lazy(() => import("../pages/SendToken"));
const CreateContract = lazy(() => import("../pages/CreateContract"));
const SendToContract = lazy(() => import("../pages/SendToContract"));
const SafeSend = lazy(() => import("../pages/SafeSend"));
const OfflineStacking = lazy(() => import("../pages/OfflineStacking"));
const RequestPayment = lazy(() => import("../pages/RequestPayment"));
const DumpKeyFile = lazy(() => import("../pages/DumpKeyFile"));
const ViewTx = lazy(() => import("../pages/ViewTx"));
const Logout = lazy(() => import("../pages/Logout"));

const LoadingFallback = () => <></>;

export const PublicRoutes = ({ children, ...rest }) => {
    return <Route {...rest} render={() => <>{children}</>}></Route>;
};

const AppRoutes = () => {
    return (
        <div className="app">
            <Layout>
                <Suspense fallback={<LoadingFallback />}>
                    <Switch>
                        <PublicRoutes path="/" exact>
                            <GenerateWallet />
                        </PublicRoutes>
                        <PublicRoutes path="/Logout" exact>
                            <Logout />
                        </PublicRoutes>
                     
                        <PublicRoutes path="/CreateRestore">
                            <Route path="/CreateRestore/CreateFromMnemonic">
                                <CreateFromMnemonic />
                            </Route>
                            <Route path="/CreateRestore/GenerateWallet">
                                <GenerateWallet />
                            </Route>
                            <Route path="/CreateRestore/RestoreWallet">
                                <RestoreWallet />
                            </Route>
                            <Route path="/CreateRestore/RestoreFromWallet">
                                <RestoreFromWallet />
                            </Route>
                            <Route path="/CreateRestore/RestoreFromMobileWallet">
                                <RestoreFromMobileWallet />
                            </Route>
                            <Route path="/CreateRestore/RestoreFromKeyFile">
                                <RestoreFromKeyFile />
                            </Route>
                        </PublicRoutes>

                        <PublicRoutes path="/OfflineStaking">
                            <Route path="/OfflineStaking/AddDelegation">
                                <AddDelegation currentInfo="Add Delegation" />
                            </Route>
                            <Route path="/OfflineStaking/OfflineStackingList">
                                <OfflineStacking />
                            </Route>
                        </PublicRoutes>

                        <PublicRoutes path="/Wallet">
                            <Route path="/Wallet/WalletInfo">
                                <WalletInfo />
                            </Route>
                            <Route path="/Wallet/ViewTx">
                                <ViewTx />
                            </Route>
                            <Route path="/Wallet/Send">
                                <SendToken />
                            </Route>
                            <Route path="/Wallet/RequestPayment">
                                <RequestPayment />
                            </Route>
                            <Route path="/Wallet/DumpKeyFile">
                                <DumpKeyFile />
                            </Route>
                            <Route path="/Wallet/SafeSend">
                                <SafeSend />
                            </Route>
                        </PublicRoutes>

                        <PublicRoutes path="/TokenContracts">
                            <Route path="/TokenContracts/CreateToken">
                                <CreateToken />
                            </Route>

                            <Route path="/TokenContracts/CreateContract">
                                <CreateContract />
                            </Route>
                            <Route path="/TokenContracts/SendToContract">
                                <SendToContract />
                            </Route>
                        </PublicRoutes>

                        <PublicRoutes path="/Setting">
                            <Setting />
                        </PublicRoutes>
                    </Switch>
                </Suspense>
            </Layout>
        </div>
    );
};

export default AppRoutes;
